import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconBefore", "iconAfter", "renderAs"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import { focusStyle, hoverStyle, addIcon, extendedSystemStyles } from "@mixins";
import { isExternalLink } from "utils/links";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var iconFunc = function iconFunc(theme, href, icon, marginCustom, marginOutgoing) {
  return icon ? addIcon(theme, icon, marginCustom) : isExternalLink(href) ? addIcon(theme, "externalLink", marginOutgoing) : "";
};

/* eslint-disable */
var PrimaryButtonLink = styled( /*#__PURE__*/forwardRef(function (_ref, ref) {
  var iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter,
    renderAs = _ref.renderAs,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(NavLink, _objectSpread({
    as: renderAs,
    ref: ref
  }, rest));
})).withConfig({
  displayName: "PrimaryButtonLink",
  componentId: "sc-m94h6l-0"
})(["&:after{", "}&:before{", "}", "", ""], function (_ref2) {
  var iconAfter = _ref2.iconAfter,
    icon = _ref2.icon,
    theme = _ref2.theme,
    href = _ref2.href;
  return iconFunc(theme, href, iconAfter || icon, "auto 0 auto 10px", "auto 0 auto 10px");
}, function (_ref3) {
  var iconBefore = _ref3.iconBefore,
    icon = _ref3.icon,
    theme = _ref3.theme,
    href = _ref3.href;
  return iconFunc(theme, href, iconBefore || icon, "auto 10px auto 0", "auto 10px auto 0");
}, function (_ref4) {
  var theme = _ref4.theme,
    disabled = _ref4.disabled,
    inverted = _ref4.inverted;
  return "\n    min-height: ".concat(theme.actionStyles.height, ";\n    font-family: ").concat(theme.fonts.robotoRegular, ";\n    font-size: ").concat(theme.fontSizes[theme.actionStyles.fontSize], ";\n    line-height: ").concat(theme.lineHeight[theme.actionStyles.lineHeight], ";\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    cursor: ").concat(disabled ? "initial" : "pointer", ";\n    pointer-events: ").concat(disabled ? "none" : "auto", ";\n\n    padding: 6px 20px 5px;\n    border-radius: ").concat(theme.actionStyles.buttonRadius, ";\n    box-shadow: ").concat(!disabled ? "inset 0 0 0 1px ".concat(theme.colors.i1) : "", ";\n\n    background: ").concat(disabled ? "".concat(theme.colors.P2, "80") : theme.colors.P2, ";\n    color: ").concat(disabled ? "".concat(theme.colors.G4).concat(theme.colors.opacitySuffix[8]) : !inverted ? theme.colors.i4 : theme.colors.P3, ";\n\n    outline: none;\n    border: none;\n    transition: all .3s;\n\n    ").concat(!disabled ? "\n      &:hover{ ".concat(hoverStyle(theme), " }\n      &:focus{ ").concat(focusStyle(theme), " }\n    ") : "");
}, extendedSystemStyles(styledSystemKeys));
PrimaryButtonLink.propTypes = {
  to: PropTypes.any.isRequired,
  iconBefore: PropTypes.string,
  iconAfter: PropTypes.string,
  align: PropTypes.oneOf(["left", "right"]),
  inverted: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default PrimaryButtonLink;